import PropTypes from "prop-types";

export default function ClickAction({
  clickHandler,
  iconProps,
  buttonProps,
  renderProps,
}) {
  if (iconProps) {
    // icon component <Icon onClick={onClick} />
  } else if (buttonProps) {
    // button component <Button onClick={onClick} />
  } else {
    return renderProps({ clickHandler });
  }
}

ClickAction.propTypes = {
  clickHandler: PropTypes.func,
};
